exports = module.exports = require("../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, ".tabs {\n  display: flex;\n  flex-direction: column; }\n  .tabs .vertical {\n    flex-direction: row; }\n\n[role='tab'] [aria-disabled] {\n  opacity: 0.5; }\n\n[role='tablist'] {\n  display: flex; }\n  [role='tablist'][aria-orientation='vertical'] {\n    flex-direction: column; }\n", ""])